module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (6).3e82643b.svg";